<template>
  <div class="padding">
    {{ $v.cookie_restriction.$model }}
    <div class="d-xl-flex">
      <FormInput
        class="form-element sm"
        v-model="$v.vat_low.$model"
        :vuelidate="$v"
        fieldName="vat_low"
        :ske="true"
        :focus="true"
        id="vat_low"
        label="BTW laag"
      />
      <FormInput
        class="form-element middle sm"
        v-model="$v.vat_high.$model"
        :vuelidate="$v"
        fieldName="vat_high"
        :ske="true"
        id="vat_high"
        label="BTW hoog"
      />
      <FormInput
        class="form-element"
        v-model="$v.shipment_price.$model"
        :vuelidate="$v"
        fieldName="shipment_price"
        :ske="true"
        id="shipment_price"
        label="Verzendkosten"
      />
    </div>
    <div class="d-xl-flex">
      <FormInput
        class="form-element"
        v-model="$v.minimum_order_amount_free_shipping.$model"
        :vuelidate="$v"
        fieldName="minimum_order_amount_free_shipping"
        :ske="true"
        id="minimum_order_amount_free_shipping"
        label="Minimum bestelbedrag gratis verzenden"
      />
      <FormInput
        class="form-element middle sm"
        v-model="$v.minimum_order_amount.$model"
        :vuelidate="$v"
        fieldName="minimum_order_amount"
        :ske="true"
        id="minimum_order_amount"
        label="Minimaal bestelbedrag"
      />
      <div class="form-element d-flex align-items-center">
        <FormCheckbox
          v-model="$v.cookie_restriction.$model"
          class="form-checkbox"
          :updateOnClick="true"
          :false-value="false"
          :true-value="true"
          :green="true"
          style="transform: translateX(-10px)"
        >
          Cookiewaarschuwing tonen
        </FormCheckbox>
      </div>
    </div>
    <FormTextarea
      v-model="$v.address.$model"
      :vuelidate="$v"
      fieldName="address"
      :ske="true"
      rows="7"
      id="address"
      label="Adresgegevens bedrijf"
    />
  </div>
</template>

<script>
import setupForm from "../../mixins/setupForm";

import FormInput from "../Inputs/FormInput.vue";
import FormTextarea from "../Inputs/FormTextarea.vue";
import FormCheckbox from "../Inputs/FormCheckbox.vue";

import { required, decimal } from "vuelidate/lib/validators";

const fields = [
  "vat_low",
  "vat_high",
  "shipment_price",
  "minimum_order_amount_free_shipping",
  "minimum_order_amount",
  "address",
  "cookie_restriction",
];

export default setupForm(
  fields,
  {
    props: {
      value: Object,
      website_type: String
    },
    components: {
      FormInput,
      FormTextarea,
      FormCheckbox,
    },
  },
  null,
  null,
  function() {
    const physicalStore = this.website_type === "physical_store";
    const getRequiredEnforcementWhenNotPhysical = () => {
      if (physicalStore) return {};
      return { required };
    };

    return {
      ...fields.reduce(
        (obj, key) => ({
          ...obj,
          [key]: {}
        }),
        {}
      ),

      ...fields.reduce(
        (obj, key) => ({
          ...obj,
          [key]: getRequiredEnforcementWhenNotPhysical()
        }),
        {}
      ),

      vat_low: {
        ...getRequiredEnforcementWhenNotPhysical(),
        decimal
      },
      vat_high: {
        ...getRequiredEnforcementWhenNotPhysical(),
        decimal
      },
      shipment_price: {
        ...getRequiredEnforcementWhenNotPhysical(),
        decimal
      },
      minimum_order_amount_free_shipping: {
        ...getRequiredEnforcementWhenNotPhysical(),
        decimal
      },
      minimum_order_amount: {
        ...getRequiredEnforcementWhenNotPhysical(),
        decimal
      },
    };

  }
);
</script>

<style scoped></style>

<style scoped src="@/assets/css/form.css"></style>
